export const getUploadPercentage = (e: ProgressEvent | number) => {
  return typeof e === 'number' ? e : Math.round((e.loaded / e.total) * 100)
}
